module.exports = __webpack_public_path__ + "static/media/icon_mapa_blue.4c66637e.svg";